import React from 'react';
import clsx from 'clsx';

export type CalloutTone = 'info' | 'warn' | 'danger' | 'ok' | 'neutral';

export interface CalloutProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  tone?: CalloutTone;
  title?: React.ReactNode;
}

const toneClasses: Record<CalloutTone, string> = {
  info: 'border-info-border bg-info-tint text-info-text',
  warn: 'border-warn-border bg-warn-tint text-warn-text',
  danger: 'border-danger-border bg-danger-tint text-danger-text',
  ok: 'border-ok-border bg-ok-tint text-ok-text',
  neutral: 'border-white/[0.08] bg-white/[0.02] text-slate-300',
};

export const Callout: React.FC<CalloutProps> = ({
  tone = 'info',
  title,
  className,
  children,
  ...props
}) => (
  <div
    className={clsx(
      'rounded-ds-md border px-3 py-2 text-xs',
      toneClasses[tone],
      className,
    )}
    {...props}
  >
    {title ? <div className="text-xs font-semibold mb-0.5">{title}</div> : null}
    <div className="text-xs leading-relaxed">{children}</div>
  </div>
);

export default Callout;
